// extracted by mini-css-extract-plugin
export var active = "_i-8";
export var addWidgetButton = "_i-9";
export var backButton = "_i-1";
export var pageContainer = "_i-2";
export var settingsContent = "_i-0";
export var sideNavContainer = "_i-6";
export var sideNavLink = "_i-7";
export var widgetContainer = "_i-5";
export var widgetSubsectionItem = "_i-3";
export var widgetSubsectionItemContent = "_i-4";